import { render, staticRenderFns } from "./Prenatales.vue?vue&type=template&id=49afe8f3"
import script from "./Prenatales.vue?vue&type=script&lang=js"
export * from "./Prenatales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports